import Vue from 'vue';
import Axios from 'axios';
import firebase from "firebase";
import {store} from '../store/store'
import axios from "axios";
import {apiAuthUrl} from "../plugins/firebase";
class BaseProxy {
  /**
   * The constructor of the BaseProxy.
   *
   * @param {string} endpoint   The endpoint being used.
   * @param {Object} parameters The parameters for the request.
   */
  constructor(endpoint, parameters = {}) {
    this.endpoint = endpoint;
    this.parameters = parameters;
    this.data = null;
    this.headers = {};
  }

  /**
   * Method used to set the query parameters.
   *
   * @param {Object} parameters The given parameters.
   *
   * @returns {BaseProxy} The instance of the proxy.
   */
  setParameters(parameters) {
    Object.keys(parameters)
      .forEach((key) => {
        this.parameters[key] = parameters[key];
      });

    return this;
  }

  toFormData(data) {
    this.data = new FormData();
    this.headers = 'multipart/form-data';
    for (const key in data) {
      if (typeof data[key] === 'object' && !data[key].hasOwnProperty('uid')) {
        this.data.append(key, JSON.stringify(data[key]));
      } else {
        this.data.append(key, data[key]);
      }
    }
  }

  setData(data) {
    this.data = data;
  }

  /**
   * Method used to set a single parameter.
   *
   * @param {string} parameter The given parameter.
   * @param {*} value The value to be set.
   *
   * @returns {BaseProxy} The instance of the proxy.
   */
  setParameter(parameter, value) {
    this.parameters[parameter] = value;
    return this;
  }

  /**
   * Method used to remove all the parameters.
   *
   * @param {Array} parameters The given parameters.
   *
   * @returns {BaseProxy} The instance of the proxy.
   */
  removeParameters(parameters) {
    parameters.forEach((parameter) => {
      delete this.parameters[parameter];
    });

    return this;
  }

  /**
   * Method used to remove a single parameter.
   *
   * @param {string} parameter The given parameter.
   *
   * @returns {BaseProxy} The instance of the proxy.
   */
  removeParameter(parameter) {
    delete this.parameters[parameter];

    return this;
  }

  /**
   * The method used to perform an AJAX-request.
   *
   * @param {string}      requestType The request type.
   * @param {string}      url         The URL for the request.
   * @param {Object|null} data        The data to be send with the request.
   *
   * @returns {Promise} The result in a promise.
   */
  async submit(requestType, url, with_headers = false, reload = false) {
    return new Promise(async (resolve, reject) => {
      Vue.$http({
          method: requestType,
          url: url + this.getParameterString(),
          data: this.data,
          headers: {
            ...Axios.defaults.headers.common,
            ...this.headers,
            'AuthMode': 'firebase'
          },
        })
        .then((response) => {
          if (with_headers) {
            resolve(response);
          } else {
            resolve(response.data);
          }
        })
        .catch(async ({response}) => {
          if (response.status === 403 && !reload) {
            if(store.state.project.id) {
              // https://stroybot-api-prod.herokuapp.com/api/v1/auth/get_auth/
              // https://stroybot-api-dev.herokuapp.com/api/v1/auth/get_auth/
              const authProxy = await axios.post(apiAuthUrl, {
                uid: authFirestore.currentUser.uid,
                projectId: this.$store.state.project.id
              });

              localStorage.setItem('api-token', authProxy.data.token)
            }
            const r  = await this.submit(requestType, url, with_headers, true)
            resolve(r)
            // localStorage.removeItem('id_token');
            // window.location.reload();
          } else if (response) {
            reject(response.data);
          } else {
            reject();
          }
        });
    });
  }

  /**
   * Method used to fetch all items from the API.
   *
   * @returns {Promise} The result in a promise.
   */
  all() {
    return this.submit('get', `/${this.endpoint}`);
  }

  /**
   * Method used to fetch a single item from the API.
   *
   * @param {string} searchString The given identifier.
   *
   * @returns {Promise} The result in a promise.
   */
  find(searchString) {
    return this.submit('get', `/${this.endpoint}/${searchString}`);
  }


  create() {
    return this.submit('post', `/${this.endpoint}`);
  }

  /**
   * Method used to update an item.
   *
   * @param {int}    id   The given identifier.
   * @param {Object} item The given item.
   *
   * @returns {Promise} The result in a promise.
   */
  update(id, item) {
    return this.submit('put', `/${this.endpoint}/${id}`, item);
  }

  /**
   * Method used to destroy an item.
   *
   * @param {int} id The given identifier.
   *
   * @returns {Promise} The result in a promise.
   */
  destroy(id) {
    return this.submit('delete', `/${this.endpoint}/${id}`);
  }


  /**
   * Method used to transform a parameters object to a parameters string.
   *
   * @returns {string} The parameter string.
   */
  getParameterString() {
    const keys = Object.keys(this.parameters);
    const parameterStrings = keys
      .filter(key => !!this.parameters[key])
      .map(key => `${key}=${this.parameters[key]}`);
    return parameterStrings.length === 0 ? '' : `?${parameterStrings.join('&')}`;
  }
}

export default BaseProxy;



// WEBPACK FOOTER //
// ./src/proxy/BaseProxy.js